import {
  type FetchDepartmentNameQuery,
  type FetchDepartmentNameQueryVariables,
  FetchDepartmentNameDocument,
} from 'domains/merchandising/api'
import { useMeshQuery } from 'legacy/apollo/clientHooks'

interface FetchDepartmentNameMeshArgs {
  departmentId: string
}

export const useGetQueryDepartmentName = ({ departmentId }: FetchDepartmentNameMeshArgs) => {
  const variables = {
    departmentId,
  }

  const { data, error, loading } = useMeshQuery<
    FetchDepartmentNameQuery,
    FetchDepartmentNameQueryVariables
  >(FetchDepartmentNameDocument, {
    fetchPolicy: 'cache-and-network',
    variables,
  })

  return {
    apiResult: data?.catalogDepartment.name,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
